module.exports = __webpack_public_path__ + "assets/img/bg-content.7fc3c37f.png";